<nav
  class="navbar navbar-expand-lg navbar-dark bg-dark sticky-top p-2"
  style="z-index: 1000"
>
  <div class="container-fluid">
    <a routerLink="/go/landing" class="navbar-brand">
      <img
        class="logo-fold"
        src="assets/images/logo/videojet-logo-blue-white-rgb.png"
        title="PQI - Aurora"
        style="max-width: 20%"
      />
    </a>
    <button
    class="navbar-toggler"
    type="button"
    data-bs-toggle="collapse"
    data-bs-target="#navbarNavDropdown"
    aria-controls="navbarNavDropdown"
    aria-expanded="false"
    aria-label="Toggle navigation"
  >
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="navbarNavDropdown">
<app-vj-main-nav-bar></app-vj-main-nav-bar>
</div>
<div class="nav navbar-nav navbar-right">
  <!-- <div class="nav navbar-nav navbar-right">
    <span (click)="openHelpModal()" class="help-button" style="cursor: pointer; padding: 10px 8px 0 0; color: darkgrey; font: bold;">
      Support
    </span>
    
  </div> -->
  
  <app-vj-profile-nav-bar></app-vj-profile-nav-bar>

</div>
<div class="flex justify-content-center flex-wrap gap-3 ml-2">
  
  <p-button icon="pi pi-comments" rounded="true" text="true" severity="info" (click)="openHelpModal()" class="fi-5"></p-button>

 

</div>
<div class="flex justify-content-center flex-wrap gap-3 ml-2">
  <p-button icon="pi pi-fw pi-sign-out" severity="danger" text="true" (click)="logout()" class="fi-5"></p-button>
</div>

    </div>
    </nav> 
    <p-progressBar mode="indeterminate" [style]="{ height: '3px' }" *ngIf="spinnerService.visibility | async"></p-progressBar>

    
 